import { Grid, IconButton, InputAdornment, debounce } from '@mui/material';
import OutlinedInput from 'components/inputs/outlined-input';
import { IActivityFeedSearch } from './types';
import { styles } from './styles';
import SearchIcon from 'assets/icons/buttons/activity-feed-search.svg';
import CrossIcon from 'assets/icons/buttons/close-search-icon.svg';

export const ActivityFeedSearch = ({
  showSearch,
  onSearchClose,
  onSearchOpen,
  onSetSearchQuery,
}: IActivityFeedSearch) => {
  const onChange = debounce(
    (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      onSetSearchQuery(event.target.value || '');
    },
    300
  );

  if (!showSearch) {
    return (
      <IconButton onClick={onSearchOpen} disableRipple={true} sx={styles.searchIcon}>
        <SearchIcon />
      </IconButton>
    );
  }

  return (
    <Grid sx={styles.searchContainer}>
      <OutlinedInput
        fullWidth
        withoutHelperText
        placeholder="Search"
        startAdornment={
          <InputAdornment position="start" sx={styles.inputAdornment}>
            <Grid item sx={{ marginRight: '10px' }}>
              <SearchIcon />
            </Grid>
          </InputAdornment>
        }
        endAdornment={
          <IconButton disableRipple={true} sx={styles.searchButton} onClick={onSearchClose}>
            <CrossIcon />
          </IconButton>
        }
        onChange={onChange}
        sx={styles.headerInput}
      />
    </Grid>
  );
};
